var _line, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBusScheduleAvgTime({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 27,
    viewBox: "0 0 151 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 13.3604,
    x2: 129,
    y2: 13.3604,
    stroke: "#0088E7",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 139.5,
    cy: 12.3604,
    r: 10,
    fill: "white",
    stroke: "#0088E7",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0062 5.87891C2.0062 4.77434 2.90163 3.87891 4.0062 3.87891H20C21.1046 3.87891 22 4.77434 22 5.87891V18.8633C22 20.244 20.8807 21.3633 19.5 21.3633H19.4605C19.2215 22.7809 17.9881 23.8608 16.5024 23.8608C15.0169 23.8608 13.7833 22.781 13.5441 21.3633H10.4622C10.2235 22.7809 8.99024 23.8608 7.50478 23.8608C6.01933 23.8608 4.7861 22.7809 4.54738 21.3633H4.5062C3.12549 21.3633 2.0062 20.244 2.0062 18.8633V13.4728C2.0021 13.436 2 13.3987 2 13.3608C2 13.323 2.0021 13.2856 2.0062 13.2488V5.87891ZM4.0062 14.3608V18.8633C4.0062 19.1395 4.23006 19.3633 4.5062 19.3633H5.5056C6.05789 19.3633 6.5056 19.811 6.5056 20.3633V20.8616C6.5056 21.4135 6.95295 21.8608 7.50478 21.8608C8.05661 21.8608 8.50396 21.4135 8.50396 20.8616V20.3633C8.50396 19.811 8.95168 19.3633 9.50396 19.3633H14.5022C15.0545 19.3633 15.5022 19.811 15.5022 20.3633V20.8608C15.5022 21.413 15.95 21.8608 16.5024 21.8608C17.0547 21.8608 17.5024 21.4131 17.5024 20.8608V20.3633C17.5024 19.811 17.9501 19.3633 18.5024 19.3633H19.5C19.7761 19.3633 20 19.1395 20 18.8633V14.3608H4.0062ZM6 12.3608H4.0062V5.87891H20V12.3608H18V8.36081C18 7.80853 17.5523 7.36081 17 7.36081H7C6.44772 7.36081 6 7.80853 6 8.36081V12.3608ZM8 12.3608H16V9.36081H8V12.3608ZM6 16.8608C6 16.3085 6.44772 15.8608 7 15.8608H8C8.55228 15.8608 9 16.3085 9 16.8608C9 17.4131 8.55228 17.8608 8 17.8608H7C6.44772 17.8608 6 17.4131 6 16.8608ZM15 16.8608C15 16.3085 15.4477 15.8608 16 15.8608H17C17.5523 15.8608 18 16.3085 18 16.8608C18 17.4131 17.5523 17.8608 17 17.8608H16C15.4477 17.8608 15 17.4131 15 16.8608Z",
    fill: "#0088E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusScheduleAvgTime);
export default __webpack_public_path__ + "static/media/bus-schedule-avg-time.15afd89c36bca85ec85ade1cd40e4c5f.svg";
export { ForwardRef as ReactComponent };